﻿import {GetParkingOperationStepsArguments} from "../../types/arguments/GetParkingOperationStepsArguments";
import {ParkingPrebookingAvailabilityArguments} from "../../types/arguments/ParkingPrebookingAvailabilityArguments";
import {ParkingPrebookingAvailabilityEntry} from "../../types/ParkingPrebookingAvailabilityEntry";
import {TariffSteps} from "../../types/TariffSteps";
import IPermitsTariffs from "../IPermitsTariffs";
import {PermitsFrontClient} from "./PermitsFrontClient";

export class PermitsTariffs implements IPermitsTariffs {
	_client: PermitsFrontClient;

	constructor(client: PermitsFrontClient) {
		this._client = client;
	}

	available(data: ParkingPrebookingAvailabilityArguments, signal?: AbortSignal | undefined): Promise<ParkingPrebookingAvailabilityEntry[]> {
		return this._client.jsonFetch("tariffs/available", "POST", data, {
			signal: signal
		});
	}

	list(data: GetParkingOperationStepsArguments, signal?: AbortSignal | undefined): Promise<TariffSteps> {
		return this._client.jsonFetch("tariffs/list", "POST", data, {
			signal: signal
		});
	}
}
